import { render, staticRenderFns } from "./LeaseTerms.vue?vue&type=template&id=37b9cda0&lang=html&"
import script from "./LeaseTerms.vue?vue&type=script&lang=js&"
export * from "./LeaseTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports